<!--
 * @Author: your name
 * @Date: 2021-08-26 17:15:19
 * @LastEditTime: 2022-12-15 11:00:56
 * @LastEditTime: 2021-08-30 16:53:11
 * @LastEditors: LAPTOP-JM4BAR46
 * @Description: In User Settings Edit
 * @FilePath: \newBj-admin\src\views\center-business\stock\out\index.vue
-->
<template>
  <div class="app-container">
    <BjRouteTabs :route-list="STOCK_DELIVERY_ROUTE_LIST" />
    <BjPage
      ref="BjPage"
      :query-params="queryParams"
      :col-span="colSpan"
      :get-action="queryApi"
      :serial="serial"
      :selection="selection"
      :before-reset-search="beforeResetSearch"
      @handleSelectionChange="handleSelectionChange"
      @showSetting="SortableTable.show"
      @header-dragend="SortableTable.handleHeaderDragend"
      @header-contextmenu="SortableTable.handleHeaderContextmenu"
    >
      <template v-slot:baseForm>
        <el-col :span="colSpan">
          <el-form-item :label="$t('form.oddNumbers')" prop="queryCode">
            <BjInputCode v-model="queryParams.queryCode" @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
        <BjSelectChannelStore
          :span="colSpan"
          :query-params="queryParams"
          :query-props="['channelTypeCode', 'shopIdList']"
          store-option-value="id"
          multiple
        />
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessStockDeliveryInform.header.status')" prop="status">
            <BjSelectLov v-model="queryParams.status" :option-list="ORDER_STOCK_OUT_TYPE_LIST" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessStockDeliveryInform.header.outLogicWarehouseCode')" prop="outLogicWarehouseCode">
            <BjInput
              v-model="queryParams.outLogicWarehouseCode"
              :maxlength="MAX_LENGTH.DEFAULT"
              :placeholder="$t('BusinessStockDeliveryInform.header.outLogicWarehouseCodeText')"
              clearable
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('table.createTimeText')" prop="beginCreationDate">
            <BjDateTimerangePicker v-model="queryParamsTime" :placeholder="$t('table.createTimeText')"/>
          </el-form-item>
        </el-col>
      </template>
      <template
        v-if="this.$route.name === 'BusinessStockDeliveryInformIndex'"
        v-slot:tableOperation="tableOperationProp"
      >
        <el-col>
          <el-button type="primary" :disabled="tableOperationProp.notSingle" @click="onDeliver"
            >{{ $t('BusinessStockDeliveryInform.ship') }}
          </el-button>
        </el-col>
      </template>
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column
            v-if="col.prop !== 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            :fixed="col.fixed || false"
            align="center"
            class-name="item"
          >
            <template slot-scope="scope">
              <div v-if="['code', 'platformOrderCode', 'orderCode'].includes(col.prop)">
                <span class="link" @click="onView(scope.row, col.prop)">{{
                  scope.row[col.prop]
                }}</span>

                <BjCopyIcon class="ml10" :copy="scope.row[col.prop]" />
              </div>

              <span v-else-if="col.prop === 'status'">{{
                $t(ORDER_STOCK_OUT_TYPE_LIST.bjGet(scope.row[col.prop]))
              }}</span>
              <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column
            v-if="col.prop === 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            :fixed="col.fixed || 'right'"
            align="center"
          >
            <template slot-scope="props">
              <el-button type="text" >按钮</el-button>
            </template>
          </el-table-column> -->
        </template>
      </template>
    </BjPage>
    <!-- 发货组件 -->
    <DeliverGoodsDialog ref="DeliverGoods" @reFresh="reFresh" />
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { stockApi } from '@/api';
import { STOCK_DELIVERY_ROUTE_LIST, ORDER_STOCK_OUT_TYPE_LIST } from '@/utils/constants';
import DeliverGoodsDialog from '@/components/BjDeliverGoodsDialog';
export default {
  name: 'BusinessStockDeliveryInformIndex',
  components: { DeliverGoodsDialog },
  mixins: [pageMiXin],
  data() {
    return {
      colSpan: 6,
      selection: true,
      STOCK_DELIVERY_ROUTE_LIST,
      ORDER_STOCK_OUT_TYPE_LIST,
      queryApi: stockApi.getOutboundDelivery,
      // 查询参数
      queryParams: {
        queryCode: null,
        channelTypeCode: null,
        shopIdList: [],
        status: null,
        outLogicWarehouseCode: null,
        beginCreationDate: null,
        endCreationDate: null,
      },
      queryParamsTime: null,
      dialogVisible: false,
      labelsVersion: 11,
      labelList: [
        { label: 'BusinessStockDeliveryInform.table.code', prop: 'code', isCheck: true, disabled: false, width: '220' },
        {
          label: 'BusinessStockDeliveryInform.table.platformOrderCode',
          prop: 'platformOrderCode',
          isCheck: true,
          disabled: false,
          width: '190',
        },
        { label: 'BusinessStockDeliveryInform.table.orderCode', prop: 'orderCode', isCheck: true, disabled: false, width: '180' },
        {
          label: 'BusinessStockDeliveryInform.table.frontRecordCode',
          prop: 'frontRecordCode',
          isCheck: true,
          disabled: false,
          width: '170',
        },
        { label: 'BusinessStockDeliveryInform.table.outTypeMeaning', prop: 'outTypeMeaning', isCheck: true, disabled: false, width: '140' },
        { label: 'BusinessStockDeliveryInform.table.status', prop: 'status', isCheck: true, disabled: false, width: '160' },
        { label: 'BusinessStockDeliveryInform.table.qty', prop: 'qty', isCheck: true, disabled: false, width: '180' },
        {
          label: 'BusinessStockDeliveryInform.table.outLogicWarehouseCode',
          prop: 'outLogicWarehouseCode',
          isCheck: true,
          disabled: false,
          width: '240',
        },
        {
          label: 'BusinessStockDeliveryInform.table.outLogicWarehouseName',
          prop: 'outLogicWarehouseName',
          isCheck: true,
          disabled: false,
          width: '240',
        },
        { label: 'BusinessStockDeliveryInform.table.shopName', prop: 'shopName', isCheck: true, disabled: false, width: '120' },
        { label: 'BusinessStockDeliveryInform.table.channelTypeCodeMeaning', prop: 'channelTypeCodeMeaning', isCheck: true, disabled: false, width: '120' },
        { label: 'table.createTimeText', prop: 'creationDate', isCheck: true, disabled: false, width: 120 },
        // { label: '操作', prop: 'bjTableAction', isCheck: true, disabled: true, width: 129},
      ],
    };
  },
  computed: {},
  watch: {
    queryParamsTime(v) {
      this.queryParams.beginCreationDate = (v || [])[0];
      this.queryParams.endCreationDate = (v || [])[1];
    },
  },
  created() {},
  mounted() {},
  methods: {
    /** 重置按钮操作 */
    beforeResetSearch() {
      this.queryParamsTime = null;
      this.queryParams.shopIdList = null;
      return new Promise(resolve => {
        resolve();
      });
    },
    /** 跳转 */
    onView(row, type) {
      if (type === 'code') {
        // this.$toPage('BusinessStockDeliveryInformView', { id: row.id });
        this.$toBusinessStockDeliveryInformView(row.id);
      }
      /** 三方单详情 */
      if (type === 'platformOrderCode') {
        this.$toBusinessThirdOrderView(row.platformOrderCode);
      }
      /** 内部单详情 */
      if (type === 'orderCode') {
        this.$toBusinessOrderInternalView(row.orderCode);
      }
      // if (type === 'frontRecordCode') {
      //   this.msgSuccess('跳转前置页面');
      // }
    },
    onDeliver() {
      const { status, code, orderCode } = this.selectedRows[0];
      // [1, '待出库'],[0, '待通知WMS'],
      if (status === 0 || status === 1) {
        // 传入出库通知单号和内部订单号
        this.$refs.DeliverGoods.show(code, orderCode);
      } else {
        this.msgError(this.$t('BusinessStockDeliveryInform.msgError'));
      }
    },
  },
};
</script>
<style lang="scss" scoped></style>
